import { render, staticRenderFns } from "./CreateEmployee.vue?vue&type=template&id=3b1514d5&"
import script from "./CreateEmployee.vue?vue&type=script&lang=js&"
export * from "./CreateEmployee.vue?vue&type=script&lang=js&"
import style0 from "./CreateEmployee.vue?vue&type=style&index=0&id=3b1514d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports